import { render, staticRenderFns } from "./ChipsDrive.vue?vue&type=template&id=422a56f0&"
import script from "./ChipsDrive.vue?vue&type=script&lang=js&"
export * from "./ChipsDrive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports